<template>
  <resource
    resource="priceLevel"
    resourceName="Preisstufe"
    :attributes="[
      {
        name: 'at_amount',
        label: 'Ab Einheiten',
        type: 'Number'
      },
      {
        name: 'bonus',
        label: 'Bonus',
        type: 'Number'
      }
    ]"
  >
    <div slot="title">
      <h4>Preisstufe erstellen</h4>
    </div>
  </resource>
</template>

<script lang="babel">
export default {}
</script>
